import React from 'react';

export type PeerReviewStatsData = {
  inReview: number;
  urgent: number;
  routine: number;
};

type PeerReviewStatsProps = {
  stats: PeerReviewStatsData;
  loading?: boolean;
};

export default function PeerReviewStats({ stats, loading }: Readonly<PeerReviewStatsProps>) {
  return (
    <div
      className="peer-review-stats"
      aria-busy={loading || undefined}
    >
      <div className="peer-review-stat-card">
        <p className="peer-review-stat-card__label">In review</p>
        <p className="peer-review-stat-card__value peer-review-stat-card__value--in-review">
          {loading ? '—' : stats.inReview}
        </p>
      </div>
      <div className="peer-review-stat-card">
        <p className="peer-review-stat-card__label">Urgent priority</p>
        <p className="peer-review-stat-card__value peer-review-stat-card__value--urgent">
          {loading ? '—' : stats.urgent}
        </p>
      </div>
      <div className="peer-review-stat-card">
        <p className="peer-review-stat-card__label">Routine</p>
        <p className="peer-review-stat-card__value peer-review-stat-card__value--routine">
          {loading ? '—' : stats.routine}
        </p>
      </div>
    </div>
  );
}
